import Header from '../Header/Header'
import homepageBg from '../../../assets/images/homepage/homepagebg.webp'
import handup from '../../../assets/images/industrypage/handup.svg'
import handdown from '../../../assets/images/industrypage/handdown.svg'

const HealthcareHero = () => {
  return (
    <section className="relative h-[550px] md:h-[650px] lg:h-[700px] xl:h-[800px] 2xl:h-[900px] overflow-hidden">

      <div className="relative z-10 h-full">
      <style>{`
  @keyframes floatTop {
    0% {
      transform: translateY(0px) rotate(0deg);
    }
    50% {
      transform: translateY(-15px) rotate(2deg);
    }
    100% {
      transform: translateY(0px) rotate(0deg);
    }
  }

  @keyframes floatBottom {
    0% {
      transform: translateY(0px) rotate(0deg);
    }
    50% {
      transform: translateY(15px) rotate(-2deg);
    }
    100% {
      transform: translateY(0px) rotate(0deg);
    }
  }

  .float-1 {
    animation: floatTop 4s ease-in-out infinite;
  }

  .float-2 {
    animation: floatBottom 4.5s ease-in-out infinite;
  }
`}
</style>

       {/* Top Right SVG */}
       <img
  src={handdown}
  alt=""
  className="pointer-events-none absolute right-0 -top-10 md:top-0 lg:top-0 xl:top-0 2xl:top-0
  h-[70%] w-[50%] md:h-[50%] md:w-[50%] lg:h-[50%] lg:w-[50%] xl:h-[55%] xl:w-[45%] 2xl:h-[50%] 2xl:w-[30%]
  float-1"
/>
         
         {/* Bottom Left SVG */}
         <img
  src={handup}
  alt=""
  className="pointer-events-none absolute left-0 -bottom-30 md:-bottom-10 lg:bottom-0 xl:bottom-0 2xl:bottom-0
  h-[70%] w-[50%] md:h-[50%] md:w-[50%] lg:h-[40%] lg:w-[40%] xl:h-[40%] xl:w-[40%] 2xl:h-[40%] 2xl:w-[30%]
  float-2"
/>
        {/* Header */}
        <Header />

        {/* Content */}
        <div className="relative h-[400px] md:h-[400px] lg:h-[500px] xl:h-[600px] 2xl:h-[700px]  mx-auto flex w-full max-w-[1600px] items-center justify-center px-4 md:px-8 lg:px-12">

          {/* Heading */}
          <h1 className="max-w-5xl text-center font-rajdhani font-bold leading-tight text-white
           text-4xl md:text-4xl lg:text-4xl xl:text-5xl 2xl:text-7xl">
            AI Automation for <br />
            Healthcare Where Precision <br />
            Saves Lives
          </h1>

        </div>
      </div>

     
    </section>
  )
}

export default HealthcareHero